import { useAuthStore } from '../auth/useAuthStore'
import { authedJSON } from './http'
import { placeOrder } from './trading'
import type {
  NormalizedOrderResult,
  OptionChainResponse,
  OptionExpirationsResponse,
  OptionInstrument,
} from './types'

function requireAccountId(): string {
  const accountId = useAuthStore.getState().accountId
  if (!accountId) throw new Error('No active account')
  return accountId
}

export async function getOptionExpirations(symbol: string): Promise<OptionExpirationsResponse> {
  const accountId = requireAccountId()
  return authedJSON<OptionExpirationsResponse>(
    `/api/accounts/${encodeURIComponent(accountId)}/options/${encodeURIComponent(symbol)}/expirations`,
  )
}

export async function getOptionChain(
  symbol: string,
  expirationDate: string,
): Promise<OptionChainResponse> {
  const accountId = requireAccountId()
  const params = new URLSearchParams({ expiration: expirationDate })
  return authedJSON<OptionChainResponse>(
    `/api/accounts/${encodeURIComponent(accountId)}/options/${encodeURIComponent(symbol)}/chain?${params}`,
  )
}

export async function placeOptionOrder(params: {
  instrument: OptionInstrument
  side: 'BUY' | 'SELL'
  contracts: number
  openCloseIndicator: 'OPEN' | 'CLOSE'
  mode: 'MARKET' | 'LIMIT'
  limitPrice?: number
}): Promise<NormalizedOrderResult> {
  if (params.mode === 'LIMIT' && params.limitPrice == null) {
    throw new Error('placeOptionOrder requires limitPrice when mode is LIMIT')
  }
  return placeOrder({
    symbol: params.instrument.symbol,
    instrumentType: 'OPTION',
    optionInstrument: params.instrument,
    side: params.side,
    type: params.mode,
    timeInForce: 'DAY',
    quantity: params.contracts,
    openClose: params.openCloseIndicator,
    ...(params.mode === 'LIMIT' ? { limitPrice: params.limitPrice } : {}),
  })
}
